import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import {getDefaultIntegrations} from "@sentry/react";

const defaultIntegrations = getDefaultIntegrations({}).filter(() => {
    // Example: Exclude CaptureConsole if you add it manually or don't need it
    // return integration.name !== 'CaptureConsole';
    return true;
});

Sentry.init({
    dsn: "https://b0454a854da7294311bacab2932bb631@o4508335801303040.ingest.de.sentry.io/4509063491551312",
    integrations: [
        ...defaultIntegrations,
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: true,
        }),
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    environment: import.meta.env.VITE_ENVIRONMENT,

    // Performance Monitoring
    tracesSampleRate: 0.1,
    tracePropagationTargets: ["localhost", /^https?:\/\/.*\.xano\.io\/api/],
    profilesSampleRate: 1.0,

    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    debug: import.meta.env.VITE_ENVIRONMENT === 'local',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
